@if(prodLoader) {
<div class="as-loader">
  <ng-lottie width="150px" height="150px" [options]="options"> </ng-lottie>
  <mat-label class="as-roboto-slab as-font-bold as-font-20 as-font-red">
    {{ 'GENERAL.loading' | translate }}...
  </mat-label>
</div>
}@else{
<div class="as-main-product-container">
  @if(dontExistProduct){
  <div class="no-results">
    <p class="as-font-semibold as-font-18">
      {{ 'GENERAL.dontExist' | translate }}
    </p>
    <p class="as-font-semibold as-font-18">
      {{ 'GENERAL.changeBranch' | translate }}
    </p>
  </div>
  }@else{
  <div class="as-product-detail-wrapper">
    <div class="as-product-container" *ngIf="product && !prodLoader">
      <div class="go-back">
        <p class="as-font-16 as-font as-font-normal as-font-grey-75 back">
          <a [routerLink]="['/']" (click)="goRoute()" class="as-pointer">{{
            'FILTER.init' | translate
          }}</a>
          >
          <a class="as-pointer" [routerLink]="product.department_url">{{
            product?.department_name | titlecase
          }}</a>
          >
          <a
            class="as-pointer"
            [routerLink]="product.department_url"
            [queryParams]="{ category: product?.category_name }"
            >{{ product?.category_name | titlecase }}</a
          >
          >
          <span class="as-font-green as-pointer as-font-semibold">{{
            product?.description | titlecase
          }}</span>
        </p>
      </div>

      <div class="as-product-info">
        <div class="as-left-container">
          <div class="as-image-container">
            <img
              class="zoom-in"
              (click)="openImagesModal(product?.zoomImage)"
              [defaultImage]="defaultImage"
              [lazyLoad]="productImage"
              onerror="this.src='assets/images/default-product.svg';"
              alt="Imagen de {{ product?.name | titlecase }}"
            />
          </div>
          @if(!isMobile){
          <div class="as-column">
            <mat-label class="as-font as-font-20 as-font-semibold">
              {{ 'GENERAL.details' | translate }}
            </mat-label>
            <p class="description">
              {{ isExpanded ? product?.long_description : truncatedDescText }}
              <ng-container *ngIf="isExpanded">
                <br />
                <span
                  *ngFor="let characteristic of product?.characteristics"
                  class="characteristic"
                >
                  {{ '- ' + characteristic | replaceParentesis }}
                </span>
              </ng-container>
              <span
                *ngIf="!isExpanded"
                class="more-link"
                (click)="toggleExpanded()"
                >... Ver más</span
              >
              <span
                *ngIf="isExpanded"
                class="less-link"
                (click)="toggleExpanded()"
              >
                Ver menos</span
              >
            </p>
          </div>
          }
        </div>

        <div class="as-product-details">
          <!-- name -->
          <h1 class="as-product-name">
            {{ product?.description }}
          </h1>
          <!-- name -->
          <div class="as-row info">
            <!-- price -->
            <div class="as-price-container">
              <div class="as-row as-gap-8 as-align-baseline">
                <mat-label
                  *ngIf="
                    product?.smart_offer !== '' && product?.offer_type === 1;
                    else normalOffer
                  "
                  class="as-font-24 as-font-semibold as-font-red-blood"
                >
                  {{ product?.smart_offer | currency : '$' }}
                </mat-label>
                <ng-template #normalOffer>
                  <mat-label
                    class="as-discount-price"
                    [ngClass]="
                      product.price === product.regular_price
                        ? ''
                        : 'as-font-red-blood'
                    "
                  >
                    {{ product?.price | currency : '$' }}
                  </mat-label>
                </ng-template>
                <mat-label
                  class="as-original-price as-font-line-through"
                  *ngIf="product.price !== product.regular_price"
                >
                  {{ product?.regular_price | currency : '$' }}
                </mat-label>
              </div>
              <!-- price -->
            </div>
          </div>
          <app-smart-label
            [product]="product"
            [options]="{
              clickable: true,
              showMore: true,
              showDiscount: true,
              isPDP: true
            }"
            (showMoreClick)="showMore()"
          ></app-smart-label>
          <div class="as-quantity-container">
            @if(!showSpinner){ @if( !productAdded){
            <!-- ADD PRODUCT -->
            <button
              [disabled]="
                product?.stock <= 0 ||
                !product?.stock ||
                ((madurityList.length > 0 || sliceList.length > 0) &&
                  productVariant === '') ||
                (productTypeQuantity === 'pza' &&
                  product?.stock < productQuantity) ||
                (productTypeQuantity !== 'pza' &&
                  product?.stock < productQuantityGrams / baseGrams)
              "
              mat-flat-button
              class="as-add-button"
              [class.as-aditional-margin]="!product?.apply_madurity"
              color="accent"
              (click)="onAddingToCart()"
            >
              <mat-label class="as-font-white as-font-semibold">
                {{
                  product?.stock > 0
                    ? ('PURCHASE.addToCart' | translate)
                    : ('PURCHASE.off' | translate)
                }}
              </mat-label>
            </button>
            <!-- ADD PRODUCT -->
            }@else{
            <!-- UPDATE PRODUCT -->
            <div
              class="as-row as-gap-16 as-quantity-wrapper"
              *ngIf="productAdded"
            >
              @if(productTypeQuantity === 'pza'){
              <div class="as-quantity-update">
                <button
                  mat-button
                  class="minus-button"
                  color="accent"
                  (click)="subtract()"
                >
                  @if(this.productQuantityGrams - this.baseGrams<=0
                  ||this.productQuantity - 1<=0){
                  <mat-icon svgIcon="ic-trash"></mat-icon>
                  }@else{
                  <mat-icon
                    style="transform: scale(1.3)"
                    svgIcon="ic-minus-white"
                  ></mat-icon>
                  }
                </button>
                <div class="input-value">
                  <input
                    mask="000000"
                    suffix=" pz"
                    (blur)="changePieces(productQuantity)"
                    [(ngModel)]="productQuantity"
                    type="text"
                    readonly
                  />
                </div>
                <button
                  [disabled]="
                    (productType === 'pza' &&
                      product?.stock <= productQuantity) ||
                    (productType === 'pza-grammage' &&
                      this.product?.stock <= productQuantityGrams / 1000)
                  "
                  class="plus-button"
                  mat-button
                  color="accent"
                  #tooltip="matTooltip"
                  matTooltip="Cantidad máxima"
                  matTooltipPosition="above"
                  [matTooltipDisabled]="
                    !(
                      (productType === 'pza' &&
                        product?.stock <= productQuantity) ||
                      (productType === 'pza-grammage' &&
                        this.product?.stock <= productQuantityGrams / 1000)
                    )
                  "
                  (click)="add()"
                >
                  <mat-icon
                    style="transform: scale(1.3)"
                    svgIcon="ic-plus-white"
                  ></mat-icon>
                </button>
              </div>
              }@else{
              <div class="as-quantity-update">
                <button
                  mat-button
                  class="minus-button"
                  color="accent"
                  (click)="subtract()"
                >
                  @if(this.productQuantityGrams - this.baseGrams<=0 ){
                  <mat-icon svgIcon="ic-trash"></mat-icon>
                  }@else{
                  <mat-icon
                    style="transform: scale(1.3)"
                    svgIcon="ic-minus-white"
                  ></mat-icon>
                  }
                </button>
                <div class="input-value">
                  <input
                    mask="000000"
                    suffix=" gr"
                    (blur)="changeGrams(productQuantityGrams)"
                    [(ngModel)]="productQuantityGrams"
                    type="text"
                    readonly
                  />
                </div>
                <button
                  [disabled]="product?.stock <= productQuantityGrams / 1000"
                  mat-button
                  class="plus-button"
                  color="accent"
                  #tooltip="matTooltip"
                  matTooltip="Cantidad máxima"
                  matTooltipPosition="above"
                  [matTooltipDisabled]="
                    !(product?.stock <= productQuantityGrams / 1000)
                  "
                  (click)="add()"
                >
                  <mat-icon
                    style="transform: scale(1.3)"
                    svgIcon="ic-plus-white"
                  ></mat-icon>
                </button>
              </div>
              }
              <div
                class="as-switch-quantity"
                *ngIf="productType === 'pza-grammage' && productAdded"
              >
                <button
                  mat-flat-button
                  class="as-type-select pieces as-mat-flat-button-left"
                  [class.as-active]="productTypeQuantity === 'pza'"
                  (click)="onSwitchTypeQuanity('pza')"
                >
                  <mat-label class="as-open-sans as-font-14 as-font-semibold">
                    {{ 'GENERAL.piece' | translate }}
                  </mat-label>
                </button>
                <button
                  mat-flat-button
                  class="as-type-select grams as-mat-flat-button-right"
                  [class.as-active]="productTypeQuantity === 'grammage'"
                  (click)="onSwitchTypeQuanity('grammage')"
                >
                  <mat-label class="as-open-sans as-font-14 as-font-semibold">
                    {{ 'GENERAL.grams' | translate }}
                  </mat-label>
                </button>
              </div>
            </div>
            <!-- UPDATE PRODUCT -->
            } }@else{
            <div class="as-spinner-button">
              <mat-spinner [diameter]="20"></mat-spinner>
            </div>
            }
          </div>

          <!-- MADURITY AND SLICE -->
          @if(madurityList.length > 0 || sliceList.length > 0){
          <div class="as-variant-wrapper">
            <div class="as-current-variant">
              <p class="as-font-12 as-open-sans as-font-grey-75">
                Variante:
                <span class="as-font-14 as-open-sans as-font-semibold">{{
                  productVariant
                }}</span>
              </p>
            </div>
            <div class="as-variants-list scrollbar-floating">
              <button
                *ngFor="
                  let variant of madurityList.length > 0
                    ? madurityList
                    : sliceList
                "
                (click)="productVariant = variant; onAddingToCart()"
                [ngClass]="{
                  'as-variant-selected': productVariant === variant
                }"
              >
                {{ variant }}
              </button>
            </div>
          </div>
          }
          <!-- ADDING NOTE -->
          <div class="as-note-container" *ngIf="productAdded">
            <div class="as-note-add">
              <div class="as-note-detail-container">
                <div class="as-note-wrapper">
                  <mat-icon svgIcon="ic-note"></mat-icon> Notas de producto
                </div>
                @if(product?.comment && !loadingNote&& !editNote){
                <p class="as-note-text">"{{ product?.comment }}"</p>
                }
              </div>
              @if(!product?.comment){ @if(!editNote){
              <button class="as-note-button" (click)="editNote = true">
                Agregar
              </button>
              } }@else{ @if(!editNote){
              <div class="as-row">
                <button
                  class="as-note-button as-font-gray-75"
                  (click)="onDeleteNote()"
                >
                  Eliminar
                </button>
                <button class="as-note-button" (click)="editNote = true">
                  Editar
                </button>
              </div>
              } }
            </div>
            @if(editNote ){
            <div class="as-input-wrapper">
              <mat-form-field
                class="as-note-input"
                color="accent"
                appearance="outline"
              >
                <mat-label>{{
                  editNote
                    ? ('PURCHASE.editNote' | translate)
                    : ('PURCHASE.addNote' | translate)
                }}</mat-label>
                <input [formControl]="noteInput" matInput type="text" />
                <mat-hint align="end"
                  >{{ noteInput.value?.length ?? '0' }} / 100</mat-hint
                >
              </mat-form-field>
              <button
                mat-flat-button
                [disabled]="
                  noteInput.invalid ||
                  !noteInput.value ||
                  loadingNote ||
                  loadingDeleteNote
                "
                mat-stroked-button
                color="accent"
                (click)="onAddingNote()"
                class="as-save"
              >
                <div
                  *ngIf="loadingNote"
                  class="as-heart-circle as-spinner-white"
                >
                  <mat-spinner [diameter]="20"></mat-spinner>
                </div>
                <p *ngIf="!loadingNote">
                  {{ 'GENERAL.save' | translate }}
                </p>
              </button>
            </div>
            }
          </div>

          <div class="as-extra-options-container">
            <div
              class="as-option-wrapper"
              (click)="
                !showHeart
                  ? addProductToFavouriteList()
                  : openSureDeleteProductFromList()
              "
            >
              <mat-icon
                svgIcon="ic-heart-simple"
                class="as-pointer"
                [ngClass]="{
                  'as-icon-green': showHeart,
                  'as-icon-grey': !showHeart
                }"
              >
              </mat-icon>
              <p
                class="as-option-name"
                [ngClass]="{
                    'as-text-green': showHeart,
                  }"
              >
                Favoritos
              </p>
            </div>
            <div class="as-option-wrapper" (click)="addProductToList()">
              <mat-icon
                svgIcon="ic-list"
                class="as-pointer as-icon-grey"
              ></mat-icon>
              <p class="as-option-name">Agregar a una lista</p>
            </div>
          </div>

          @if(isMobile){
          <div class="as-column">
            <mat-label
              class="as-font as-font-semibold"
              [ngClass]="{ 'as-font-20': !isMobile, 'as-font-14': isMobile }"
            >
              {{ 'GENERAL.details' | translate }}
            </mat-label>
            <p class="description">
              {{ isExpanded ? product?.long_description : truncatedDescText }}
              <ng-container *ngIf="isExpanded">
                <br />
                <span
                  *ngFor="let characteristic of product?.characteristics"
                  class="characteristic"
                >
                  {{ '- ' + characteristic | replaceParentesis }}
                </span>
              </ng-container>
              <span
                *ngIf="!isExpanded"
                class="more-link"
                (click)="toggleExpanded()"
                >... Ver más</span
              >
              <span
                *ngIf="isExpanded"
                class="less-link"
                (click)="toggleExpanded()"
              >
                Ver menos</span
              >
            </p>
          </div>
          }
        </div>
      </div>
      <div class="separator"></div>
      <div class="as-carrousels-container">
        <ng-container *ngIf="recommendedToBuy?.length; else skeleton">
          <div class="as-list">
            <div class="as-row as-justify-sb as-align-end">
              <mat-label class="as-roboto-slab as-font-24 as-font-bold">
                Recomendados
              </mat-label>
            </div>
            <carousel
              [height]="carouselProductsHeight"
              [autoplay]="false"
              [arrows]="!isMobile && recommendedToBuy.length > 7"
              class="as-row"
              *ngIf="loadingProducts && isBrowser"
              [margin]="10"
              [cellWidth]="carouselProductsWidth"
            >
              <app-product-card
                class="carousel-cell"
                *ngFor="let product of recommendedToBuy"
                [product]="product"
              >
              </app-product-card>
            </carousel>
          </div>
        </ng-container>
        <ng-container *ngIf="patrocinado_1?.items?.length; else skeleton">
          <div class="as-list">
            <div class="as-row as-justify-sb as-align-end">
              <mat-label class="as-roboto-slab as-font-24 as-font-bold">
                {{ patrocinado_1.title }}
              </mat-label>
              <a
                [routerLink]="patrocinado_1?.product_url"
                [queryParams]="{ id: patrocinado_1?.carrousel_id }"
                class="as-font-green as-font-semibold as-pointer"
                (click)="onSeeMoreNavigation()"
              >
                {{ 'PURCHASE.seeMore' | translate }}
              </a>
            </div>
            <carousel
              [height]="carouselProductsHeight"
              [autoplay]="false"
              [arrows]="!isMobile && patrocinado_1?.items?.length > 7"
              class="as-row"
              *ngIf="loadingProducts && isBrowser"
              [margin]="10"
              [cellWidth]="carouselProductsWidth"
            >
              <app-product-card
                class="carousel-cell"
                *ngFor="let product of patrocinado_1?.items"
                [product]="product"
              >
              </app-product-card>
            </carousel>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  }

  <ng-template #skeleton>
    <div class="as-skeleton-container">
      <div class="as-skeleton-title"></div>
      <div class="as-skeleton-card-container">
        <div class="as-skeleton-card" *ngFor="let product of skeletonList">
          <div class="as-image-skeleton"></div>
          <div class="as-description-line as-line-1"></div>
          <div class="as-description-line as-line-2"></div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
}
